/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DeadwoodRipLayers, Layers} from "../view/DeadwoodRipLayers";
import {DeadwoodRip} from "../DeadwoodRip";
import {Translation} from "../../core/utils/Translation";
import {gsap, TimelineLite} from "gsap";
import {DeadwoodRipSound} from "../sound/DeadwoodRipSound";
import {BigWinCountUp} from "../winpresentation/presentations/bigwin/BigWinCountUp";
import {DeadwoodRipGameAssets} from "../DeadwoodRipGameAssets";

export class WinCapScreen extends ContinueScreen {

    private _youWin:PIXI.Sprite;
    private _image:PIXI.Sprite;
    private _spine:PIXI.spine.Spine;
    private _spineEffect:PIXI.spine.Spine;
    private _countUp:BigWinCountUp;

    private _textTl:TimelineLite | null;

    private _isPlaying:boolean;

    constructor() {
        super(DeadwoodRipLayers.getLayer(Layers.SCREENS)!);

        this._image = new PIXI.Sprite();
        this._image.anchor.set(0.5);
        this._image.position.set(360, 360);
        this._container.addChild(this._image);

        this._played = new PIXI.Text("", new PIXI.TextStyle({
            fill : 0xffffff,
            fontFamily : OpenSans.FAMILY,
            wordWrap : false,
            fontWeight : FontWeight.BOLD,
            fontSize : 30
        }));
        this._played.anchor.set(0.5, 0.5);
        this._played.visible = false;
        this._container.addChild(this._played);

        this._youWin = new PIXI.Sprite();
        this._youWin.position.set(360, 412);
        this._container.addChild(this._youWin);

        const youWin0 = new PIXI.BitmapText(`100`, {
            fontName : DeadwoodRipGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 66,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        (<PIXI.Point>youWin0.anchor).set(0, 0.82);
        youWin0.letterSpacing = -30;
        const youWin1 = new PIXI.BitmapText(`000x`, {
            fontName : DeadwoodRipGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 66,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        (<PIXI.Point>youWin1.anchor).set(1, 0.82);
        youWin1.letterSpacing = -30;
        this._youWin.addChild(youWin0);
        this._youWin.addChild(youWin1);
        youWin0.updateTransform();
        youWin1.updateTransform();
        const textWidth = youWin0.textWidth + youWin1.textWidth + 20;
        youWin0.x = -textWidth * 0.5;
        youWin1.x = textWidth * 0.5;

        this._countUp = new BigWinCountUp();
        this._countUp.y = 450;
        this._container.addChild(this._countUp);
    }

    public show(onContinueCallBack:() => void):TimelineLite {
        this._isPlaying = true;
        DeadwoodRip.xBetController.featureVisible = false;
        // const win = SlotGame.apiPlugin.currency.formatValue(data.totalWin);
        this._spine = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset("capWin"));
        this._spine.autoUpdate = true;
        this._image.addChild(this._spine);
        this._spineEffect = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset("bwEffect"));
        this._spineEffect.autoUpdate = true;
        this._image.addChild(this._spineEffect);

        this._youWin.visible = false;
        const spinPlayed = DeadwoodRip.model.parsedGameData.numberOfFreespinsPlayed;
        this._played.text = Translation.translation("Spins played: ${spinPlayed}").replace("${spinPlayed}", spinPlayed.toString());
        DeadwoodRipSound.fadeMusic(0, 100);
        DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.CAP_WIN_COUNT_UP});
        const loopTl = new TimelineLite();
        loopTl.add(() => {
            if(this._isPlaying) {
                DeadwoodRipSound.playLoopEffect(DeadwoodRipSound.CAP_WIN_LOOP);
            }
        }, 22.129);

        return super.show(onContinueCallBack);
    }

    protected getShowAnimations():TimelineLite {
        const tl = new TimelineLite();
        tl.add([
            this._countUp.getCountUpAnimation(0, DeadwoodRip.model.parsedGameData.totalWin, 13.35),
            () => {
                this._countUp.visible = true;
                this._countUp.scale.set(0.5);
                gsap.to(this._countUp.scale, {duration : 1, x : 1, y : 1});
                this._spine.state.setAnimation(0, "capWin", false);
                this._spineEffect.state.setAnimation(0, "effect", true);
                DeadwoodRip.initialCountUp.remove();
                DeadwoodRip.bigWinCountUp.remove();
                DeadwoodRip.waysWon.remove();
            }
        ]);
        tl.add([
            () => {
                this._spine.state.setAnimation(0, "loop", true);
                this._youWin.visible = true;
                this._youWin.scale.set(1.2, 1.2);
                this.startTextLoop();
            },
            gsap.to(this._countUp.scale, {duration : 0.5, x : 2.5, y : 2.5}),
            gsap.to(this._countUp, {duration : 0.3, alpha : 0, delay : 0.2})
        ]);
        tl.add(() => {
            this._played.visible = DeadwoodRip.model.parsedGameData.mode !== GameMode.NORMAL;
            this._countUp.visible = false;
        });
        return tl;
    }

    private startTextLoop():void {
        if(this._textTl) {
            this._textTl.paused();
            this._textTl.kill();
        }

        const tl = new TimelineLite();
        tl.add(gsap.to(this._youWin.scale, {duration : 5, x : 1, y : 1, ease : "power2.out"}));
        tl.add(gsap.to(this._youWin.scale, {duration : 0.1, x : 1.1, y : 1.1}));
        tl.add(() => {
            if(this._isPlaying) {
                this.startTextLoop();
            }
        });
        this._textTl = tl;
    }

    protected close():TimelineLite {
        const tl = super.close();
        tl.add(() => {
            this._isPlaying = false;
            if(this._textTl) {
                this._textTl.paused();
                this._textTl.kill();
            }
            this._textTl = null;
            const player = DeadwoodRipSound.soundPlayer.fetchSoundPlayer(DeadwoodRipSound.CAP_WIN_COUNT_UP);
            if(player && player.isPlaying) {
                DeadwoodRipSound.fadeAndStopSound({
                    name : DeadwoodRipSound.CAP_WIN_COUNT_UP,
                    to : 0,
                    duration : 500
                });
            }

            DeadwoodRipSound.stopLoopEffect(DeadwoodRipSound.CAP_WIN_LOOP);
            DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.FREE_SPIN_OUTRO_END});
            DeadwoodRipSound.switchMusic(
                {name : DeadwoodRipSound.MAIN_GAME_MUSIC, volume : 1},
                {name : DeadwoodRipSound.MAIN_GAME_MUSIC, to : 1, duration : 10}
            );
            DeadwoodRip.xBetController.featureVisible = true;
            DeadwoodRip.background.updateMode(DeadwoodRip.model.data.nextMode);
        }, 0);
        tl.add(() => {
            this._spine.state.setEmptyAnimations(0);
            this._image.removeChild(this._spine);
            this._spine.destroy();
            this._spineEffect.state.setEmptyAnimations(0);
            this._image.removeChild(this._spineEffect);
            this._spineEffect.destroy();
            this._played.visible = false;
            this._countUp.alpha = 1;
            this._youWin.visible = false;
            this._youWin.alpha = 1;
        });
        return tl;
    }
}